import React, { Component } from 'react';
import cookie from 'react-cookie';

import ResultPage from '../components/ResultPage';
import QuestionContainer from '../components/QuestionContainer';
import LoginPage from '../components/LoginPage';
import SharingPage from '../components/SharingPage';
import ProgressBar from '../components/ProgressBar';

class SeriousGame extends Component {
    constructor(props){
        super(props);

        var loginInfo = this.getLoginInfo();
        var userEmail = '';
        if(this.props.dontCheckEmail != true) {
            if (loginInfo !== false && typeof loginInfo.email !== 'undefined') {
                userEmail = loginInfo.email;
                //cookie.save('idix-serious-game-email', userEmail, {path:'/'});
            }
            if (userEmail === '') {
                var cookieEmail = cookie.load('idix-serious-game-email');
                if (typeof cookieEmail !== 'undefined' && cookieEmail !== false && cookieEmail.trim() !== '') {
                    userEmail = cookieEmail;
                }
            }
        }

        var pageCount = this.props.questionList.length;
        pageCount += 3; // 3 = loadingPage +  loginPage + resultPage

        this.state = {
            loading: true,
            started: false,
            index: 0,
            completed: false,
            showResult: false,
            showSharingPage: false,
            userEmail: userEmail,
            questionCount: this.props.questionList.length,
            answers: [],
            pageCount: pageCount,
            pageNumber: 1,
            resultAlreadySend: false,
            winners: [],
            optins: []
        };

        this.handleLoadingEnd = this.handleLoadingEnd.bind(this);
        this.handleAnswerSelected = this.handleAnswerSelected.bind(this);
        this.handlePreviousQuestion = this.handlePreviousQuestion.bind(this);
        this.handleRestart = this.handleRestart.bind(this);
        this.handleEmailSave = this.handleEmailSave.bind(this);
        this.handleUnload = this.handleUnload.bind(this);
        this.handleGetWinners = this.handleGetWinners.bind(this);
        this.handleGoToShare = this.handleGoToShare.bind(this);
        this.handleGoBackToResult = this.handleGoBackToResult.bind(this);
        this.handleGoBackToLogin = this.handleGoBackToLogin.bind(this);
        this.handleGoBackToLastQuestion = this.handleGoBackToLastQuestion.bind(this);
        this.handleSaveResultCallback = this.handleSaveResultCallback.bind(this);
        this.handlePageChange(0, 'loading');
    }

    componentDidMount(){
        window.addEventListener('beforeunload', this.handleUnload);
    }

    handleGoToShare(){
        this.setState({
            showSharingPage: true,
            pageNumber: this.state.pageNumber + 1
        });
        this.handlePageChange(+1, 'sharing');
    }

    handleGetWinners(winners)
    {
        this.setState({
            winners: winners
        });
    }

    handleUnload(event){
        if(this.state.started && !this.state.showResult){
            event.preventDefault();

            event.returnValue = 'Vous êtes en train de quitter la page, souhaitez-vous réellement quitter ce jeu en cours de route ?';

            return 'Vous êtes en train de quitter la page, ssouhaitez-vous réellement quitter ce jeu en cours de route ?';
        }
        return true;
    }

    handleRestart(evt){
        setTimeout(function(){
            this.setState({
                index:0,
                started:false,
                answers:[],
                completed:false,
                showResult:false,
                showSharing:false,
                pageNumber: 2,
                resultAlreadySend: false,
                winners:[]
            });
            this.handlePageChange(0, 'restart');
        }.bind(this), 300);
    }

    handleAnswerSelected(event){
        this.setUserAnswer(event.currentTarget);

        const nextIndex = this.state.index + 1;
        if(nextIndex >= this.state.questionCount){
            setTimeout(() => this.setCompleted(), 300);
        }else {
            setTimeout(() => this.setNextQuestion(nextIndex), 300);
        }
    }

    handleLoadingEnd(evt){
        evt.preventDefault();
        this.setState({
            loading:false,
            started: true,
            pageNumber: this.state.pageNumber+1
        });
        this.handlePageChange(+1, 'question');
    }

    handlePreviousQuestion(evt){
        if(this.state.index - 1 < 0){
            this.handleRestart(evt);
        }else {
            this.setState({
                index: this.state.index - 1,
                pageNumber: this.state.pageNumber - 1
            });
            this.handlePageChange(-1, 'question');
        }
    }

    handlePageChange(direction, pageType)
    {
        if(this.props.changeScreenCallback !== null){
            try{
                var screenParams = {
                    pageNumber: this.state.pageNumber,
                    pageCount: this.state.pageCount,
                    questionIndex: this.state.index,
                    questionCount: this.state.questionCount,
                    pageType: pageType,
                    direction: direction
                };
                this.props.changeScreenCallback.call(
                    null,
                    screenParams
                );
            }catch(e){
                console.log(e);
            }
        }
    }

    handleEmailSave(email, optins){
        if(this.props.dontCheckEmail == true){
            email = 'anonymous@noemail.com';
        }else {
            cookie.save('idix-serious-game-email', email, {path: '/'});
        }
        this.setState({
            userEmail: email,
            showResult: true,
            optins: optins,
            pageNumber: this.state.pageNumber+1
        });
        this.handlePageChange(+1, 'result');
    }

    handleGoBackToResult(evt){
        this.setState({
            showResult: true,
            showSharingPage: false,
            pageNumber: this.state.pageNumber-1
        });
        this.handlePageChange(-1, 'result');
    }

    handleGoBackToLogin(){
        this.setState({
            completed: true,
            showResult: false,
            showSharingPage: false,
            pageNumber: this.state.pageNumber-1
        });
        this.handlePageChange(-1, 'login');
    }

    handleGoBackToLastQuestion(){
        this.setState({
            completed: false,
            resultAlreadySend: false,
            index: this.state.questionCount - 1,
            pageNumber: this.state.pageNumber - 1
        });
        this.handlePageChange(-1, 'question');
    }

    handleSaveResultCallback(params){
        if(typeof this.props.saveResultCallback === 'function' && !this.state.resultAlreadySend) {
            this.props.saveResultCallback.call(null, params);
            this.setState({
                resultAlreadySend: true
            });
        }
    }

    setUserAnswer(answer){
        var questionIndex = Number(answer.name.replace('isg_question_', ''));
        var answerIndex = Number(answer.value);
        var currentAnswers = this.state.answers;
        currentAnswers[questionIndex] = answerIndex;
        this.setState({
            answers: currentAnswers
        });
    }

    setCompleted(){
        this.setState({
            completed: true,
            pageNumber: this.state.pageNumber + 1
        });
        this.handlePageChange(+1, 'login');
    }

    setNextQuestion(nextIndex){
        this.setState({
            index: nextIndex,
            pageNumber: this.state.pageNumber + 1
        });
        this.handlePageChange(+1, 'question');
    }

    getLoginInfo(){
        var loginInfo = false;
        if(this.props.loginInfoCallback !== null){
            try{
                loginInfo = this.props.loginInfoCallback.call();
            }catch(e){
                console.log(e);
            }
        }
        return loginInfo;
    }

    renderSharingPage(){
        return (
          <SharingPage
              handleRestart={this.handleRestart}
              handleGoBackToResult={this.handleGoBackToResult}
              winners={this.state.winners}
              imgBanner={this.props.wording.imgBanner}
              partenaire={this.props.wording.partenaire}
              gameTitle={this.props.wording.title}
              imgAccueil={this.props.wording.imgAccueil}
              shorturl={this.props.wording.shorturl}
              siteLabel={this.props.wording.siteLabel}
              twitterAccount={this.props.wording.twitterAccount}
          />
        );
    }

    renderResult(){
        return (
            <ResultPage
                resultList={this.props.resultList}
                questionList={this.props.questionList}
                answers={this.state.answers}
                optins={this.state.optins}
                handleRestart={this.handleRestart}
                saveResultCallback={this.handleSaveResultCallback}
                handleGetWinners={this.handleGetWinners}
                handleGoToShare={this.handleGoToShare}
                userEmail={this.state.userEmail}
                imgBanner={this.props.wording.imgBanner}
                url={this.props.wording.url}
            />
        );
    }

    renderQuestionContainer(){
        return(
              <QuestionContainer
                  questionList={this.props.questionList}
                  questionCount={this.state.questionCount}
                  index={this.state.index}
                  handleAnswerSelected={this.handleAnswerSelected}
                  currentAnswers={this.state.answers}
                  themeList={this.props.themeList}
                  imgBanner={this.props.wording.imgBanner}
              />
        );
    }

    renderLoadingPage(){
        if(this.props.wording.imgAccueil !== ''){
            return (
                <div className="isg_panel isg_loading isg_bg_base">
                    <button
                        className="isg_img_btn"
                        onClick={this.handleLoadingEnd}
                    >
                        <img src={this.props.wording.imgAccueil} alt="" />
                    </button>
                </div>
            );
        }else{
            return (
                <div className="isg_panel isg_loading isg_bg_base">
                    <div className="isg_panel_content">
                        <p className="isg_loading_description" dangerouslySetInnerHTML={{__html: this.props.wording.description}}></p>
                        <button
                            className="isg_btn"
                            onClick={this.handleLoadingEnd}
                        >C'est parti !</button>
                    </div>
                </div>
            );
        }

    }

    renderLoginPage(){
        return (
            <LoginPage
                userEmail={this.state.userEmail}
                handleEmailSave={this.handleEmailSave}
                handleFocusEmail={this.props.handleFocusEmail}
                handleBlurEmail={this.props.handleBlurEmail}
                optinList={this.props.optinList}
                imgBanner={this.props.wording.imgBanner}
                dontCheckEmail={this.props.dontCheckEmail}
            />
        );
    }
    
    render (){
        var content = '';
        var progress = '';
        var pageNum = 0;
        var pageCount = 0;
        if(this.state.completed){
            if(this.state.showResult){
                if(this.state.showSharingPage){
                    content = this.renderSharingPage();
                    // Callback = retour vers résultat
                    pageNum = this.state.index + 3;
                    pageCount = this.state.questionCount + 2;
                    /*progress = (
                        <ProgressBar
                            pageNumber={pageNum}
                            pageCount={pageCount}
                            handlePrevious={this.handleGoBackToResult}
                        />
                    );*/
                    progress = '';
                }else {
                    content = this.renderResult();
                    // Callback = retour vers login
                    pageNum = this.state.index + 3;
                    pageCount = this.state.questionCount + 2;
                    /*progress = (
                        <ProgressBar
                            pageNumber={pageNum}
                            pageCount={pageCount}
                            handlePrevious={this.handleGoBackToLogin}
                        />
                    );*/
                    progress = '';
                }
            }else{
                content = this.renderLoginPage();
                // Callback = retour vers dernière question
                pageNum = this.state.index + 2;
                pageCount = this.state.questionCount + 2;
                progress = (
                    <ProgressBar
                        pageNumber={pageNum}
                        pageCount={pageCount}
                        handlePrevious={this.handleGoBackToLastQuestion}
                    />
                );
            }
        }else if(this.state.started){
            content = this.renderQuestionContainer();
            // Callback = retour à question précédente sauf si index = 0
            pageNum = this.state.index + 1;
            pageCount = this.state.questionCount + 2;
            progress = progress = (
                <ProgressBar
                    pageNumber={pageNum}
                    pageCount={pageCount}
                    handlePrevious={this.handlePreviousQuestion}
                />
            );
        }else{
            content = this.renderLoadingPage();
        }
        var className = "idix_seriousgame idix_seriousgame_" + this.props.cssTheme;
        return (
            <div className={className}>
                {content}
                {progress}
            </div>
        );
    }
}

SeriousGame.propTypes = {
    cssTheme: React.PropTypes.string.isRequired,
    wording: React.PropTypes.object.isRequired,
    themeList: React.PropTypes.array.isRequired,
    resultList: React.PropTypes.array.isRequired,
    questionList: React.PropTypes.array.isRequired,
    optinList: React.PropTypes.array.isRequired,
    changeScreenCallback: React.PropTypes.func,
    loginInfoCallback: React.PropTypes.func,
    saveResultCallback: React.PropTypes.func,
    handleFocusEmail: React.PropTypes.func,
    handleBlurEmail: React.PropTypes.func,
    dontCheckEmail: React.PropTypes.bool
};

export default SeriousGame;


/** WEBPACK FOOTER **
 ** ./src/components/SeriousGame.js
 **/